import React, { Component } from "react";
import { Link } from "react-router-dom";

import { get } from "../../api";
import capitalize from "../../capitalize";
import { addListener, removeListener } from "../../events";
import { emit } from "../../events";

import AddLBU from "./AddLBU";
import LBUDetails from "./LBUDetails";
import Address from "../Address/Address";

import "./LBUs.css";

const fromCamelCase = word => capitalize(word.replace(/([A-Z])/g, " $1"));

const stripHTML = word => word.replace(/<[^>]+>/g, "");

const clip = word => (word.length < 35 ? word : word.substr(0, 35) + "...");

class LBUs extends Component {
  state = {};

  componentDidMount() {
    addListener("lbu_updated", this.onLBUUpdated);
    addListener("lbu_cloned", this.onLBUAdded);
    addListener("lbu_deleted", this.onLBUDeleted);
    if (this.props.match.params.id && this.props.match.params.id !== "add") {
      this.fetchLBU(this.props.match.params.id);
    }
    if (
      this.props.match.params.query &&
      this.props.match.params.query.length > 0
    ) {
      this.fetchLBUs(this.props.match.params.query);
      this.setState({ query: this.props.match.params.query });
    }
  }

  componentWillUnmount() {
    removeListener("lbu_updated", this.onLBUUpdated);
    removeListener("lbu_cloned", this.onLBUAdded);
    removeListener("lbu_deleted", this.onLBUDeleted);
  }

  componentDidUpdate(prevProps, prevState) {
    const id = this.props.match.params.id;
    if (id !== prevProps.match.params.id) {
      if (id === undefined || id === "add") {
        this.setState({ lbu: null });
      } else {
        this.fetchLBU(id);
      }
    }

    if (prevProps.match.params.query !== this.props.match.params.query) {
      if (
        this.props.match.params.query &&
        this.props.match.params.query !== this.state.query
      ) {
        this.fetchLBUs(this.props.match.params.query);
        this.setState({ query: this.props.match.params.query });
      }
    } else if (!this.state.lbus && this.state.query) {
      this.fetchLBUs(this.state.query);
    }

    if (prevState.lbus !== this.state.lbus) {
      emit("scroll_to_top");
    }
  }

  onLBUUpdated = lbu => {
    if (this.state.lbu && this.state.lbu.id === lbu.id) {
      this.setState({ lbu });
      emit("snackbar", "LBU updated");
    }
  };

  onLBUDeleted = lbu => {
    if (this.state.lbu && this.state.lbu.id === lbu.id) {
      this.setState({
        lbu: null,
        lbus: this.state.lbus.filter(item => item.id !== lbu.id)
      });
      this.closeModal();
      emit("snackbar", "LBU deleted");
    }
  };

  onLBUAdded = lbu => {
    this.setState({ lbu });
    this.props.history.replace("/lbus/" + lbu.id + "/basic");
    setTimeout(() => {
      this.fetchLBUs(this.state.query);
    }, 2000);
  };

  fetchLBU = async id => {
    try {
      const lbu = await get("/lbus/" + id);
      this.setState({ lbu });
    } catch (err) {
      alert(err.message);
    }
  };

  fetchLBUs = async query => {
    try {
      const lbus = await get("/search", {
        q: query || "",
        unpublished: true
      });
      this.setState({ lbus });
    } catch (err) {
      alert(err.message);
    }
  };

  closeModal = () => {
    let url = ["/lbus"];
    if (this.state.query) {
      url.push("query");
      url.push(encodeURIComponent(this.state.query));
    }
    this.props.history.replace(url.join("/"));
  };

  render() {
    const { lbus = [], lbu } = this.state;

    return (
      <div className="LBUs">
        <ul>
          {lbus.map((lbu, index) => {
            return (
              <li key={lbu.id}>
                <Link
                  onClick={() => this.setState({ lbu })}
                  to={`/lbus/${lbu.id}/basic`}
                >
                  <h2 className="name">
                    <span className="number">{index + 1}.</span>
                    {lbu.name}
                    {!lbu.published && (
                      <span className="notPublished">Not published</span>
                    )}
                    {(lbu.sitemaps.length > 0) && (
                      <span className="sitemaps">Sitemaps</span>
                    )}
                    {(lbu.seedpage && lbu.seedpage.length > 0) && (
                      <span className="seedpage">Seedpage</span>
                    )}
                    {(lbu.chainId && lbu.chainId.length > 0) && (
                      <span className="seedpage">Chained</span>
                    )}
                    {(lbu.scraper && lbu.scraper.scraped > 0) && (
                      <span className="scraped">Scraped</span>
                    )}
                  </h2>
                </Link>
                {lbu.homepage && (
                  <a
                    style={{ fontSize: "12px" }}
                    target="_blank"
                    href={lbu.homepage}
                  >
                    {lbu.homepage}
                  </a>
                )}
                <div>
                  <Address address={lbu.address} inline="true" />
                </div>
                {Object.keys(lbu.highlight || {})
                  .filter(key => key !== "names")
                  .map((key, index) => (
                    <div key={index}>
                      <label>{fromCamelCase(key)}</label>
                      <ul className="result">
                        {lbu.highlight[key].map((match, index) => (
                          <li key={index}>{capitalize(stripHTML(match))}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                {lbu.crawled.category && (
                  <div>
                    <label>Category page ({lbu.crawled.category.total})</label>
                    <ul className="result">
                      {lbu.crawled.category.hits.map((item, index) => (
                        <li key={index}>
                          <a href={item.url} title={item.title} target="_blank">
                            {clip(item.title)}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {lbu.crawled.brand && (
                  <div>
                    <label>Brand page ({lbu.crawled.brand.total})</label>
                    <ul className="result">
                      {lbu.crawled.brand.hits.map((item, index) => (
                        <li key={index}>
                          <a href={item.url} title={item.title} target="_blank">
                            {clip(item.title)}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {lbu.crawled.product && (
                  <div>
                    <label>Product page ({lbu.crawled.product.total})</label>
                    <ul className="result">
                      {lbu.crawled.product.hits.map((item, index) => (
                        <li key={index}>
                          <a href={item.url} title={item.title} target="_blank">
                            {clip(item.title)}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
        {lbu && <LBUDetails lbu={lbu} onClose={this.closeModal} />}
        {this.props.add && (
          <AddLBU onAdded={this.onLBUAdded} onClose={this.closeModal} />
        )}
      </div>
    );
  }
}

export default LBUs;



// WEBPACK FOOTER //
// ./src/components/LBUs/LBUs.js